// 根据环境区分配置
// 构建时通过 VUE_APP_ENV 指定环境：dev | test | prod
const env = process.env.VUE_APP_ENV || (process.env.NODE_ENV === 'production' ? 'prod' : 'dev')

const envConfig = {
  // 本地开发环境
  dev: {
    apiHost: 'http://192.168.0.28:8443',
    frontendHost: 'http://192.168.0.28:8080',
    publicPath: '/',
    dingtalkCorpId: 'ding6f0f4fcf3d4268d9acaaa37764f94726'
  },
  // 测试环境（123.57.25.81）
  test: {
    apiHost: 'http://123.57.25.81',
    frontendHost: 'http://123.57.25.81',
    publicPath: '/',
    dingtalkCorpId: 'ding6f0f4fcf3d4268d9acaaa37764f94726'
  },
  // 生产环境（华友钉钉，10.223.0.6）
  prod: {
    apiHost: 'http://43.173.14.150',
    frontendHost: 'http://43.173.14.150',
    publicPath: '/',
    dingtalkCorpId: 'ding6aa476dce23b89fe35c2f4657eb6378f'
  }
}

const current = envConfig[env] || envConfig.dev

// 后端服务地址
export const API_HOST = current.apiHost

// 前端服务地址（用于二维码、下载链接等）
export const FRONTEND_HOST = current.frontendHost

// 前端打包后的资源根路径
export const ASSETS_PUBLIC_PATH = current.publicPath

// 钉钉 CorpId
export const DINGTALK_CORP_ID = current.dingtalkCorpId

// ============================================
// 关键：打印当前环境配置到控制台和服务器日志
// 用于排查测试环境钉钉配置是否正确加载
// ============================================
const configInfo = {
  env: env,
  apiHost: current.apiHost,
  frontendHost: current.frontendHost,
  dingtalkCorpId: current.dingtalkCorpId,
  corpIdPrefix: current.dingtalkCorpId ? current.dingtalkCorpId.substring(0, 20) + '...' : 'empty'
}

// 立即打印到浏览器控制台
console.log('[Config] 当前环境配置:', configInfo)
console.log('[Config] 钉钉 CorpId:', current.dingtalkCorpId)
console.log('[Config] 构建环境变量 VUE_APP_ENV:', process.env.VUE_APP_ENV)
console.log('[Config] NODE_ENV:', process.env.NODE_ENV)

// 通过图片请求发送到 Nginx 日志（延迟执行，确保 API_HOST 已定义）
setTimeout(() => {
  try {
    const payload = {
      t: 'Config',
      m: '前端环境配置加载',
      e: JSON.stringify(configInfo),
      ts: Date.now(),
      ua: (navigator.userAgent || '').substring(0, 200),
      url: typeof window !== 'undefined' ? window.location.href : ''
    }
    const qs = Object.keys(payload).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(payload[k] || '')).join('&')
    const img = new Image()
    img.src = current.apiHost + '/__log__?' + qs
  } catch (e) {
    // 忽略日志发送错误
  }
}, 100)


// WEBPACK FOOTER //
// ./src/config/api.js